// Patch the existing media-gallery element to add null safety
document.addEventListener('DOMContentLoaded', function() {
  // Wait for media-gallery to be defined
  customElements.whenDefined('media-gallery').then(() => {
    const mediaGalleries = document.querySelectorAll('media-gallery');
    
    mediaGalleries.forEach(gallery => {
      const originalSetActiveMedia = gallery.setActiveMedia;
      
      if (originalSetActiveMedia) {
        gallery.setActiveMedia = function(mediaId, prepend) {
          const activeMedia =
            this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
            this.elements.viewer.querySelector('[data-media-id]');
          
          if (!activeMedia) {
            return;
          }
          
          this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
            element.classList.remove('is-active');
          });
          activeMedia?.classList?.add('is-active');

          if (prepend) {
            if (activeMedia.parentElement) {
              activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);
            }

            if (this.elements.thumbnails) {
              const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
              if (activeThumbnail && activeThumbnail.parentElement) {
                activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
              }
            }

            if (this.elements.viewer.slider) this.elements.viewer.resetPages();
          }

          this.preventStickyHeader();
          window.setTimeout(() => {
            if (!this.mql.matches || this.elements.thumbnails) {
              if (activeMedia.parentElement) {
                activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
              }
            }
            const activeMediaRect = activeMedia.getBoundingClientRect();
            if (activeMediaRect.top > -0.5) return;
            const top = activeMediaRect.top + window.scrollY;
            window.scrollTo({ top: top, behavior: 'smooth' });
          });
          this.playActiveMedia(activeMedia);

          if (!this.elements.thumbnails) return;
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (activeThumbnail) {
            this.setActiveThumbnail(activeThumbnail);
            if (activeThumbnail.dataset.mediaPosition) {
              this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
            }
          }
        };
      }
    });
  });
});

